import React from 'react';

import { FormCustomFieldRendererParams } from '@/components/Form';

import { FormAssignmentRestriction } from '../components/AssignmentRestriction';

export const renderFormAssignmentRestriction =
  (props: {
    contentName: string;
    className?: string;
    overrides?: React.ComponentProps<typeof FormAssignmentRestriction>['overrides'];
  }) =>
  (formikData: FormCustomFieldRendererParams) => {
    const { contentName, className, overrides } = props;
    const { value, onChange } = formikData;

    return (
      <FormAssignmentRestriction
        assignmentRestriction={value}
        className={className}
        contentName={contentName}
        overrides={overrides}
        onChange={onChange}
      />
    );
  };
